import React, { useEffect } from 'react';
import DashboardRevenueReport from './DashboardRevenueReport';
import SupplierSalesReport from './DashBoardSupplierReports/SupplierSalesReport';
import TaxInvoiceAgaistSalesOrderReport from 'pages/DashboardNew/SalesOrderReport/TaxInvoiceAgaistSalesOrderReport';
import SupplierPoReport from 'pages/DashboardNew/SupplierPo/SupplierPoReport';

export default function DashBoardNewTest() {

  // Error handling for ResizeObserver
  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      try {
        entries.forEach(entry => {
          if (entry.target) {
          }
        });
      } catch (error) {
        console.warn('ResizeObserver loop error: ', error);
      }
    });
    const observedElements = document.querySelectorAll('.resize-observed'); // Change this to the relevant selector
    observedElements.forEach(element => {
      observer.observe(element);
    });
    // Cleanup observer on component unmount
    return () => {
      observer.disconnect();
    };
  }, []);



  return (
    <div className=" bg-gray-100 flex flex-col">
      {/* Header */}
      <header className="bg-blue-500 text-white shadow-md p-2 rounded-lg mx-3 mt-6">
        <h1 className="text-sm font-bold text-white-A700">ERP Dashboard</h1>
      </header>
      {/* Main Dashboard Layout */}
      <main
        className="flex-1 p-1"
        style={{
          maxHeight: 'calc(100vh - 150px)',
          overflowY: 'auto',
        }}
      >
        <div className="grid grid-cols-1  lg:grid-cols-1 gap-2">
          {/* Revenue Report Section */}
          <div className="bg-white shadow-md rounded-lg pl-5  mt-2  resize-observed">
            <h2 className="text-lg font-semibold text-gray-600">
              Sales Report
            </h2>
            <DashboardRevenueReport hiddenSection={true} />
          </div>

          {/* Supplier Sales Report Section */}
          <div className="bg-white shadow-md rounded-lg p-5 resize-observed">
            <h2 className="text-lg font-semibold text-gray-600">
              Supplier Sales Report
            </h2>
            <SupplierSalesReport hiddenSection={true} />
          </div>
        </div>

        {/* supplier po and tax invoice */}

        <div className="grid grid-cols-1  lg:grid-cols-1 gap-2">
          {/* Revenue Report Section */}
          <div className="bg-white shadow-md rounded-lg p-5 resize-observed">
            <h2 className="text-lg font-semibold text-gray-600">
              Sales Order Report
            </h2>
            {/* <DashboardRevenueReport hiddenSection={true} /> */}
            <TaxInvoiceAgaistSalesOrderReport />
          </div>

          {/* Supplier Sales Report Section */}
          <div className="bg-white shadow-md rounded-lg p-5 resize-observed">
            <h2 className="text-lg font-semibold text-gray-600">
              Supplier PO Report
            </h2>
            {/* <SupplierSalesReport hiddenSection={true} /> */}
            <SupplierPoReport />
          </div>
        </div>
      </main>


    </div>
  );
}
